import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from "../config/Params";
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useParams } from 'react-router-dom'; 
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Loader from "../components/Loader";
import GuideSidebar from "../components/GuideSidebar";

const ListingReports = () => {
  const [loading, setLoading] = useState(true);
  const [reports, SetReports] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {      
    const fetchRatingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
  
      setLoading(true);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.listingReports}`,
          data: formData,
        });
  
        if (response.data.items && Array.isArray(response.data.items)) {
            SetReports(response.data.items);
        } else {
          console.log('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchRatingData();
  }, []);

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
        <Helmet>
            <title>Listing's Reports</title>
            <meta name='description' content='' />
        </Helmet>

        <div className='row'>
          <div className='col-md-8'>
            <div className="ap-offer-section">
              <div className="apoffbx">
                {reports.length > 0 ? (
                  <div className='row'>
                    {reports.map((report, index) => (
                      <div key={index} className='col-md-6'>
                        <div className="card mb-3 listing-report-box">
                          <div className='category-img-sections'>
                              <div className="apimgcibox" style={{boxShadow:'none', padding:'0'}}>
                                  <div className='image-wrapper lcibox' style={{width:'100%'}}>
                                      <div className='ac-cover-image'>
                                          <img
                                              src={report.cover_photo || '/assets/img/default_listing.jpg'}
                                              alt={report.listing_title || 'Untitled Listing'}
                                              className="ciso ap-ciso"
                                              style={{height:'180px'}}
                                          />
                                          <div className='aci-overlay'></div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div style={{padding:'20px', paddingTop:'0'}}>
                            <div className='category-data-header cat-pointer lrpntr'>
                              <img src={report.property_title_icon_image} alt="Profile" className="pointer-icon" />
                              <div className='wspl-ta-section'>
                                <span className='wspl-title-box'>{report.listing_title || 'Unknown Title'}</span>
                                <span className='wspl-add-box'>{report.property_address}</span>
                              </div>
                            </div>
                            <div className='category-data-header cat-pointer lrpntr'>
                              <img src={'/assets/img/icons/common_point_icon.png'} alt="Profile" className="pointer-icon" />
                              <span className="cp-txt">
                                Reported on - {new Date(report.report_created_time).toLocaleDateString('en-GB', {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                })}
                              </span>
                            </div>
                            <div className='category-data-header cat-pointer lrpntr'>
                              <img src={'/assets/img/icons/common_point_icon.png'} alt="Profile" className="pointer-icon" />
                              <span className="cp-txt">
                                Reason - {
                                  (() => {
                                  const title = report.report_reason_name?.trim();
                                  const text = title || 'Unknown Title';

                                  const words = text.split(/\s+/);
                                  return words.length > 3
                                      ? words.slice(0, 3).join(' ') + '...'
                                      : text;
                                  })()
                                }
                              </span>
                            </div>
                            {/*<div className='category-data-header cat-pointer'>
                              <img src={'/assets/img/icons/common_point_icon.png'} alt="Profile" className="pointer-icon" />
                              <span className="cp-txt">
                                Description - {
                                  report.report_comment.split(' ').length > 20
                                    ? report.report_comment.split(' ').slice(0, 20).join(' ') + '...'
                                    : report.report_comment
                                }
                              </span>
                            </div>*/}
                            <a href={`/listing-report-details/${report.listing_report_id}`} className='co-host-box'>
                                <span className='acc-btn-txt'>View Report</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-chat-section ems">
                    <img src={'/assets/img/placeholder/no_rating_yet.svg'} className='empty-image img-fluid' alt='' />
                    <p>No listing reports found.</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='col-md-4 p-0'>
            <GuideSidebar slug="listing-reports" />
          </div>

        </div>

        
    </div>
  );
};

export default ListingReports;
